module.exports = __webpack_public_path__ + "thedyrt-logo.png?397c83ac365e823813d9015359b374c6";